module.exports = __webpack_public_path__ + "img/events.12d55ae0.jpg";